import { TypeUser } from "@/types/UtilisateurType";

export type ConfigFormulaireType = Record<
  TypeUser.PARTICULIER | TypeUser.ENTREPRISE,
  { fields: string[] }
>;

export const PUBLIC_TYPE_USERS: TypeUser[] = [
  TypeUser.PARTICULIER,
  TypeUser.ENTREPRISE,
];

export const COMMON_TYPE_USERS: TypeUser[] = [
  TypeUser.PARTICULIER,
  TypeUser.ENTREPRISE,
  TypeUser.ADMINISTRATEUR,
  TypeUser.VETERINAIRE,
  TypeUser.TECHNIQUE,
  TypeUser.TERRAIN,
  TypeUser.OFFICIER,
  TypeUser.FOURNISSEUR,
  TypeUser.SANITAIRE,
  TypeUser.AUTRE,
];

export const configFormulaire: ConfigFormulaireType = {
  [TypeUser.PARTICULIER]: {
    fields: [
      "prenom",
      "nom",
      "dateNaissance",
      "adresse.intituleRue",
      "villeNaissance",
      "villeActivite",
    ],
  },
  [TypeUser.ENTREPRISE]: {
    fields: [
      "nom",
      "matricule",
      "dateCreation",
      "adresse.pays",
      "adresse.ville",
      "adresse.intituleRue",
      "adresse.numeroRue",
    ],
  },
};
